import PropTypes from 'prop-types';

const PaperEffect = ({ className, width, height }) => {
    // Fold size scales with the smaller dimension (≈13%, matching original proportions)
    const fold = Math.round(Math.min(width, height) * 0.13);

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true">
            <defs />
            {/* Paper outline with corner fold */}
            <path style={{ stroke: 'rgb(177,180,182)', fill: 'none' }} strokeLinecap="round"
                d={`M ${width - fold - 1} 1 L ${width - 1} ${fold + 1} L ${width - 1} ${height - 1} L 1 ${height - 1} L 1 1 L ${width - fold - 1} 1 Z`} />
            {/* Fold triangle */}
            <path style={{ stroke: 'rgb(177,180,182)', fill: 'rgb(255,255,255)' }} strokeLinecap="round"
                d={`M ${width - fold} 1 L ${width - 1} ${fold} L ${width - fold} ${fold} L ${width - fold} 1 Z`} />
            {/* Corner fill to mask the missing rectangle above the fold */}
            <path style={{ stroke: 'rgb(177,180,182)', strokeWidth: 0, fill: 'rgb(255,255,255)' }} vectorEffect="non-scaling-stroke" strokeLinecap="round"
                d={`M${width - 0.8} ${fold + 0.5}L${width - fold - 0.8} 0.5 ${width - 0.8} 0.5 ${width - 0.8} ${fold + 0.5}Z`} />
        </svg>
    );
};

PaperEffect.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
};

export default PaperEffect;
